import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const speciesRegistryService = createApi({
    reducerPath: 'speciesRegistryService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['SpeciesRegistry'],
    endpoints: (builder) => ({
        getAllSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getSpeciesRegistryById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadSpeciesRegistry: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.speciesRegistryController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllSpeciesRegistryMutation,
    useSaveSpeciesRegistryMutation,
    useUpdateSpeciesRegistryMutation,
    useDeleteSpeciesRegistryMutation,
    useGetSpeciesRegistryByIdMutation,
    useFindAllSpeciesRegistryMutation,
    useBulkUploadSpeciesRegistryMutation,
} = speciesRegistryService;
